import { render, staticRenderFns } from "./collectionReporterTable.vue?vue&type=template&id=940d7a4a&scoped=true"
import script from "./collectionReporterTable.vue?vue&type=script&lang=ts"
export * from "./collectionReporterTable.vue?vue&type=script&lang=ts"
import style0 from "./collectionReporterTable.vue?vue&type=style&index=0&id=940d7a4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940d7a4a",
  null
  
)

export default component.exports